import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { memo } from 'react';
import { useQuery } from 'urql';
import PropTypes from 'prop-types';
import { OTHERS_YOU_MAY_LIKE_ID } from '../../../../components/RecommendationsAI/constants';
import RecommendationsAI from '../../../../components/RecommendationsAI';
import { jsx as _jsx } from "react/jsx-runtime";

var Loading = function Loading() {
  return /*#__PURE__*/_jsx("div", {
    "aria-busy": "true"
  });
};

var Recommendations = function Recommendations(_ref) {
  var data = _ref.data;
  var variantIds = Object.values(data).map(function (datum) {
    return datum.variant.shopifyId;
  });
  return /*#__PURE__*/_jsx(RecommendationsAI, {
    id: OTHERS_YOU_MAY_LIKE_ID,
    full: true,
    title: "You Might Also Like",
    variantIds: variantIds
  });
};

Recommendations.propTypes = {
  data: PropTypes.shape({})
};

var RecommendationsLoader = function RecommendationsLoader(_ref2) {
  var items = _ref2.items;
  var emsColorwayGids = items.map(function (item) {
    return item.emsColorwayGid;
  });
  var queryContent = emsColorwayGids.map(function (id, i) {
    var colorway = "colorway".concat(i + 1);
    return "\n      ".concat(colorway, ": colorway(id: \"").concat(id, "\") {\n        variant {\n          shopifyId\n        }\n      }\n    ");
  }).join('');
  var wishListItemsColorwaysQuery = "\n    query AllItemColorways {\n      ".concat(queryContent, "\n    }\n  ");

  var _useQuery = useQuery({
    query: wishListItemsColorwaysQuery
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsx(Loading, {});
  }

  return /*#__PURE__*/_jsx(Recommendations, {
    data: data
  });
};

RecommendationsLoader.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({}))
};
export default /*#__PURE__*/memo(RecommendationsLoader);